import { lazy } from '../../shared/deployment';

export const vmDispatchActions = lazy(() => import('./vmDispatchActions'));
